"use client";
import React, { useContext } from "react";
import dynamic from "next/dynamic";

import { ContentLoader } from "@stadium/ui/src/components/loaders/loaders";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

const NavBar = dynamic(() => import("./nav-bar"), {
  loading: () => <ContentLoader />,
});

const LeftNavBar = ({ isAuthenticated = true, isLoading, application }) => {
  const { isDesktopDevice } = useContext(CurrentDeviceContext);

  if (isLoading) return;

  return isDesktopDevice && isAuthenticated && <NavBar application={application} />;
};

export default LeftNavBar;
